import * as React from 'react';
import styled from 'styled-components';
import { TypographyProps, Heading1 } from "--components/typography";
const BASE_SIZE = 48;

const StyledTitle = styled(Heading1)`
    font-size: ${BASE_SIZE}px;
    line-height: ${BASE_SIZE}px;
    white-space: nowrap;

    &>span:nth-child(1),
    &>span:nth-child(4) {
        color: ${props => props.theme.palette.text.secondary}
    }
    &>span:nth-child(2) {
        color: ${props => props.theme.palette.text.primary}
    }
    &>span:nth-child(3) {
        color: ${props => props.theme.palette.primary.main}
    }
`;

type WorkspaceTitleProps = TypographyProps & {
    workspaceName?: string
    brandName?: string
    tld?: string
}

const WorkspaceTitle: React.FC<WorkspaceTitleProps> = ({workspaceName, brandName, tld, ...typoProps}) => {
    const titleRef = React.useRef<HTMLElement>(null);

    React.useLayoutEffect(()=>{
        if (!titleRef.current) return;
        const title = titleRef.current;
        title.style.fontSize = BASE_SIZE + "px";
        const offsetWidth = titleRef.current.offsetWidth;
        const scrollWidth = titleRef.current.scrollWidth;
        title.style.fontSize = Math.min((offsetWidth / scrollWidth) * BASE_SIZE, BASE_SIZE) + "px";
    }, [workspaceName, brandName, tld]);

    return <StyledTitle ref={titleRef} {...typoProps}>
        <span>{workspaceName && workspaceName + '.'}</span>
        <span>{brandName || "floji"}</span>
        <span>.</span>
        { tld && <span>{tld}</span> }
    </StyledTitle>
}
    

export default WorkspaceTitle;
export { WorkspaceTitle, WorkspaceTitleProps };

